import React, { useState } from 'react'
import DefaultPhoto from 'url:./user_default.png'

function UserProfilePhoto(props: { src?: string; className?: string }) {
	const [imgSrc, setImgSrc] = useState(props.src || DefaultPhoto)
	return <img className={props.className} src={imgSrc} onError={() => setImgSrc(DefaultPhoto)} />
}

export default UserProfilePhoto
